/* global gtag */
/* global fbq */
import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import( './views/Home.vue')
const Product2 = () => import('./views/Product2.vue')
const Categories = () => import('./views/Categories.vue')
import store from '@/store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { transitionName: 'slide' },
    },
    {
      path: '/contact',
      name: 'contact',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/offers',
      name: 'offers',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Offers.vue')
    },
    {
      path: '/product/:productId',
      name: 'product2',
      component: Product2,
      meta: { transitionName: 'slide' },
    },
    {
      path: '/productfood/:productId',
      name: 'productfood',
      meta: { transitionName: 'slide' },
      component: () => import('./views/ProductFood.vue')
    },
    {
      path: '/categories/:categoryId',
      name: 'categories',
      component: Categories,
      meta: { transitionName: 'slide' },
    },
    {
      path: '/register',
      name: 'register',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Register.vue')
    },
    {
      path: '/address',
      name: 'address',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Address.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Login.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MyProfile.vue')
    },
    {
      path: '/cart',
      name: 'cart',
      meta: { transitionName: 'slide' },
      component: () => import('./views/NewCart.vue')
    },
    {
      path: '/validation',
      name: 'validation',
      meta: { transitionName: 'slide' },
      component: () => import('./views/ValidationCode.vue')
    },
    {
      path: '/map',
      name: 'map',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Map.vue')
    },
    {
      path: '/history',
      name: 'history',
      meta: { transitionName: 'slide' },
      component: () => import('./views/History2.vue')
    },
    {
      path: '/forgot',
      name: 'forgot',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Forgot.vue')
    },
    {
      path: '/card',
      name: 'card',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Card.vue')
    },
    {
      path: '/changePass',
      name: 'changePass',
      meta: { transitionName: 'slide' },
      component: () => import('./views/ChangePass.vue')
    },
    {
      path: '/membership_prizes',
      name: 'membership_prizes',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipPrizes.vue')
    },
    {
      path: '/membership_points',
      name: 'membership_points',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipPoints.vue')
    },
    {
      path: '/membership_orders',
      name: 'membership_orders',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipOrders.vue')
    },
    {
      path: '/membership_scan',
      name: 'membership_scan',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipScan.vue')
    },
    {
      path: '/membership_prize/:prize_id',
      name: 'membership_prize',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipPrizeDetail.vue')
    },
    {
      path: '/membership_success',
      name: 'membership_success',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipOrderSuccess.vue')
    },
    {
      path: '/membership_address',
      name: 'membership_address',
      meta: { transitionName: 'slide' },
      component: () => import('./views/MembershipAddress.vue')
    },
    {
      path: '/company_list/:lat?/:lng?',
      name: 'company_list',
      meta: { transitionName: 'slide' },
      component: () => import('./views/CompanyList.vue')
    },
    {
      path: '/chat/:channelName/:shopperId',
      name: 'chat',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Chat.vue')
    },
    {
      path: '/welcome',
      name: 'welcome',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Welcome2.vue')
    },
    {
      path: '/search',
      name: 'search',
      meta: { transitionName: 'slide' },
      component: () => import('./views/SearchView.vue')
    },
    {
      path: '/ongoing',
      name: 'ongoing',
      meta: { transitionName: 'slide' },
      component: () => import('./views/OnGoing.vue')
    },
    {
      path: '/wasteless',
      name: 'wasteless',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Wasteless.vue')
    },
    {
      path: '/cards',
      name: 'cards',
      meta: { transitionName: 'slide' },
      component: () => import('./views/Cards.vue')
    }
  ],
  scrollBehavior () {
    // console.log('apply scroll')
    return store.state.breadCrumbSavedPosition
  }
})

router.afterEach((to) => {
  store.state.showLoading = false

  if (to.fullPath === '/') {
    router.push({path: '/home'})
  }

  // send path to google
  if (store.state.googleKeyAnalytics){
    gtag('config', store.state.googleKeyAnalytics, {'page_path': to.path});
  }
  //send path to facebook
  if (store.state.facebookPixel) {
    fbq('track', 'ViewContent', {content_name: to.path})
  }
  if ((typeof(window.Konduto) !== "undefined") &&
    (typeof(window.Konduto.sendEvent) !== "undefined")) {
    window.Konduto.sendEvent('page', to.path)
  }

})

router.beforeEach ((to, from, next) => {

  // if marketplace do not load any page before choice the subcompany
  //if (store.state.company && store.state.company.market_place && !store.state.choicedCompanyId && to.name !== 'login' && to.name !== 'history' && to.name !== 'profile' && to.name !== 'register' && to.name !== 'welcome' && to.name !== 'validation' && to.name !== 'forgot' && to.name !== 'changePass' && to.path.indexOf('registration') === -1 && to.name !== 'company_list' && to.name !== 'address') {
  if (store.state.company && store.state.company.market_place && !store.state.choicedCompanyId && (to.name === 'home' || to.name === 'product2' || to.name === 'categories')) {
    location.reload()
  }

  if (to.name === 'login' && from.name !== 'validation') {
    store.state.registerRequestOrigin = from.name
    store.state.registerLoginOrigin = from.name
  }
  // chain bread crumb
  store.state.breadCrumb.push({
    from: from,
    to: to,
    scrollY: store.state.currentScrollY,
    lastLimitProducts: store.state.lastLimitProducts,
    searchTerm: store.state.searchTerm,
    activeSearch: store.state.activeSearch
  })
  if (store.state.breadCrumb.length > 10) {
    store.state.breadCrumb.shift()
  }
  next()
})

export default router
